import React, { useState } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import {
  Calendar,
  Clock,
  User,
  Phone,
  Mail,
  MessageSquare,
  ChevronLeft,
  CheckCircle,
  Heart,
  MapPin,
  Stethoscope,
  XCircle,
  Facebook,
  Video
} from 'lucide-react';
import './Booking.css';

const services = [
  { id: 'consultation', name: 'استشارة نساء وتوليد', duration: '30 دقيقة', price: '500 جنيه' },
  { id: 'pregnancy-follow', name: 'متابعة حمل', duration: '20 دقيقة', price: '400 جنيه' },
  { id: 'high-risk-pregnancy', name: 'متابعة الحمل الحرج', duration: '30 دقيقة', price: '600 جنيه' },
  { id: 'infertility', name: 'علاج تأخر الحمل', duration: '45 دقيقة', price: '800 جنيه' },
  { id: 'icsi', name: 'استشارة ICSI / حقن مجهري', duration: '60 دقيقة', price: '1000 جنيه' },
  { id: 'pgd', name: 'استشارة PGD / تشخيص وراثي', duration: '45 دقيقة', price: '900 جنيه' },
  { id: 'laparoscopy', name: 'استشارة مناظير جراحية', duration: '30 دقيقة', price: '700 جنيه' },
  { id: 'followup', name: 'متابعة بعد العلاج', duration: '20 دقيقة', price: '300 جنيه' },
];

const timeSlots = [
  'male' , 'female'
];

const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5 },
};

const Booking = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: 'email@example.com',
    age: 35,
    gender: 'female',
    notes: '',
    status: "pending"
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [selectedService, setSelectedService] = useState(null);

  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [age, setAge] = useState('');
  const [address, setAddress] = useState('');

  const handelGender = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const hanleNotes = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleServiceSelect = (service) => {
    setSelectedService(service);
    setFormData({ ...formData, notes: service.name });
  };

  const [foundError, setFoundError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    axios.post('https://dr-mohamed-khaled.site/api/patients', formData, 
      {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(response => {
        console.log('Booking successful:', response.data);
        setIsSubmitted(true);
      })
      .catch(error => {
        console.error('Error booking appointment:', error);
        setFoundError(true);
      });
  };

  if (isSubmitted === true) {
    return (
      <div className="booking-page">
        <section className="booking-success">
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="success-card"
          >
            <div className="success-icon">
              <CheckCircle size={64} />
            </div>
            <h2>تم تأكيد حجزكِ بنجاح!</h2>
            <p>شكراً لاتصالكِ بعيادة د. محمد خالد. سوف نقوم بالرد عليكِ في أقرب وقت.</p>
            <div className="success-details">
              <div className="success-detail">
                <User size={18} />
                <span>{formData.name}</span>
              </div>
              <div className="success-detail">
                <Stethoscope size={18} />
                <span>{services.find(s => s.name === formData.notes)?.name}</span>
              </div>
            </div>
            <motion.button
              className="btn-success"
              onClick={() => {
                setIsSubmitted(false);
                setFormData({
                  name: '', phone: '', email: '', service: '', date: '', time: '', notes: '',
                });
                setSelectedService(null);
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              حجز موعد جديد
            </motion.button>
          </motion.div>
        </section>
      </div>
    );
  }

  if (foundError) {
    return (
      <div className="booking-page">
        <section className="booking-success">
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="success-card"
          >
            <div className="success-icon">
              <XCircle size={64} />
            </div>
            <h2>يرجى التأكد من المعلومات ومحاولة الحجز مرة أخرى!</h2>
            <div className="success-details">
              <div className="success-detail">
                <User size={18} />
                <span>{formData.name}</span>
              </div>
              <div className="success-detail">
                <Stethoscope size={18} />
                <span>{services.find(s => s.name === formData.notes)?.name}</span>
              </div>
            </div>
            <motion.button
              className="btn-success"
              onClick={() => {
                setFoundError(false);
                setFormData({
                  name: '', phone: '', email: '', service: '', date: '', time: '', notes: '',
                });
                setSelectedService(null);
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              حجز موعد جديد
            </motion.button>
          </motion.div>
        </section>
      </div>
    );
  }

  return (
    <div className="booking-page">
      {/* Hero */}
      <section className="booking-hero">
        <div className="booking-hero-bg">
          <div className="booking-hero-gradient"></div>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="booking-hero-content"
        >
          <div className="booking-hero-badge">
            <Calendar size={14} />
            <span>حجز موعد</span>
          </div>
          <h1>احجزي موعدكِ بسهولة</h1>
          <p>اختري الخدمة المناسبة وسنقوم بالتواصل معكِ للتأكيد</p>
        </motion.div>
      </section>

      <div className="booking-container">
        {/* Info Sidebar */}
        <motion.aside
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="booking-info"
        >
          <div className="info-card">
            <h3>مواعيد العيادات</h3>

            <div className="info-item">
              <MapPin size={18} />
              <div>
                <span className="info-label">المقطم</span>
                <span className="info-value">عمارة 163 بجوار صيدلية ناريمان</span>
                <span className="info-value" style={{color: '#c9a84c', fontSize: '13px'}}>
                  الأحد والثلاثاء: 8 - 11 م | الخميس: 1 - 4 ظ
                </span>
              </div>
            </div>

            <div className="info-item">
              <MapPin size={18} />
              <div>
                <span className="info-label">مدينة نصر - مركز كابيتال للإنجاب</span>
                <span className="info-value">49 شارع محيي الدين عبد الحميد من عباس العقاد</span>
                <span className="info-value" style={{color: '#c9a84c', fontSize: '13px'}}>
                  الاثنين والخميس: 10 - 12 ص
                </span>
              </div>
            </div>

            <div className="info-item">
              <MapPin size={18} />
              <div>
                <span className="info-label">مستشفى الزراعيين - الدقي</span>
                <span className="info-value" style={{color: '#c9a84c', fontSize: '13px'}}>
                  السبت: 12 - 2 م | الأربعاء: 10 - 12 م
                </span>
              </div>
            </div>

            <div className="info-item">
              <MapPin size={18} />
              <div>
                <span className="info-label">الشروق - بانوراما مول</span>
                <span className="info-value" style={{color: '#c9a84c', fontSize: '13px'}}>
                  مواعيد متعددة طوال الأسبوع
                </span>
              </div>
            </div>
          </div>

        <div className="info-card contact-card">
  <h3>للحجز والاستعلام</h3>

  {/* المقطم */}
  <div className="contact-clinic">
    <span className="contact-clinic-name">📍 المقطم</span>
    <div className="contact-numbers">
      <a href="https://wa.me/201126276505" target="_blank" rel="noopener noreferrer" className="contact-number-btn">
        <span className="contact-icon whatsapp-icon">
          <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
        </span>
        <span className="contact-number-text">واتساب الحجز: 01126276505</span>
      </a>
      <a href="tel:+20226688042" className="contact-number-btn">
        <span className="contact-icon phone-icon">
          <Phone size={16} />
        </span>
        <span className="contact-number-text">0226688042</span>
      </a>
    </div>
  </div>

  {/* مدينة نصر */}
  <div className="contact-clinic">
    <span className="contact-clinic-name">📍 مدينة نصر</span>
    <div className="contact-numbers">
      <a href="https://wa.me/201140147994" target="_blank" rel="noopener noreferrer" className="contact-number-btn">
        <span className="contact-icon whatsapp-icon">
          <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
        </span>
        <span className="contact-number-text">واتساب الحجز: 01140147994</span>
      </a>
    </div>
  </div>

  {/* مستشفى الزراعيين */}
  <div className="contact-clinic">
    <span className="contact-clinic-name">📍 مستشفى الزراعيين</span>
    <div className="contact-numbers">
      <a href="tel:+202333776677" className="contact-number-btn">
        <span className="contact-icon phone-icon">
          <Phone size={16} />
        </span>
        <span className="contact-number-text">02333776677 داخلي 161</span>
      </a>
    </div>
  </div>

  {/* الشروق - بانوراما مول */}
  <div className="contact-clinic">
    <span className="contact-clinic-name">📍 الشروق - بانوراما مول</span>
    <div className="contact-numbers">
      <a href="https://wa.me/201104044537" target="_blank" rel="noopener noreferrer" className="contact-number-btn">
        <span className="contact-icon whatsapp-icon">
          <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
        </span>
        <span className="contact-number-text">واتساب الحجز: 01104044537</span>
      </a>
    </div>
  </div>

  {/* طبيب الطوارئ */}
  <div className="contact-clinic emergency-clinic">
    <span className="contact-clinic-name">🚨 طبيب الطوارئ</span>
    <div className="contact-numbers">
      <a href="tel:+201289444600" className="contact-number-btn emergency-btn">
        <span className="contact-icon phone-icon">
          <Phone size={16} />
        </span>
        <span className="contact-number-text">طوارئ: 01289444600</span>
      </a>
    </div>
  </div>
</div>

          {/* <div className="info-card">
            <h3>تابعونا</h3>
            <div className="info-item">
              <Facebook size={18} />
              <div>
                <a href="https://www.facebook.com/share/1DGkN6yJi7/" target="_blank" rel="noopener noreferrer" className="info-value" style={{color: '#1877f2'}}>
                  صفحة الفيسبوك
                </a>
              </div>
            </div>
            <div className="info-item">
              <Video size={18} />
              <div>
                <a href="https://www.tiktok.com/@dr.mohamed.khaled.t?_r=1&_t=ZS-97wtDkci8aw" target="_blank" rel="noopener noreferrer" className="info-value" style={{color: '#000'}}>
                  تيك توك
                </a>
              </div>
            </div>
          </div> */}

          {/* <div className="info-card emergency">
            <Heart size={24} className="emergency-icon" />
            <h4>حالة طوارئ؟</h4>
            <p>في حالات الطوارئ، يرجى الاتصال بالرقم التالي مباشرة</p>
            <a href="tel:+201289444600" className="emergency-phone">
              01289444600
            </a>
          </div> */}
        </motion.aside>

        {/* Booking Form */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="booking-form-wrapper"
        >
          <form onSubmit={handleSubmit} className="booking-form">
            {/* Step 1: Service Selection */}
            <div className="form-step">
              <h3 className="step-title">
                <span className="step-number">1</span>
                اختري الخدمة
              </h3>
              <div className="services-selection">
                {services.map((service) => (
                  <motion.div
                    key={service.id}
                    className={`service-option ${selectedService?.id === service.id ? 'selected' : ''}`}
                    onClick={() => handleServiceSelect(service)}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    <div className="service-option-header">
                      <Stethoscope size={20} />
                      <span className="service-name">{service.name}</span>
                    </div>
                    <div className="service-option-meta">
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>

            {/* Step 2: Personal Info */}
            <div className="form-step">
              <h3 className="step-title">
                <span className="step-number">2</span>
                البيانات الشخصية
              </h3>
              <div className="form-grid">
                <div className="form-group">
                  <label>
                    <User size={14} />
                    الاسم الكامل *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="أدخلي اسمكِ الكامل"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>
                    <Phone size={14} />
                    رقم الهاتف *
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="مثال: 01234567890"
                    required
                  />
                </div>
                {/* <div className="form-group full-width">
                  <label>
                    <Mail size={14} />
                    البريد الإلكتروني (اختياري)
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="example@email.com"
                  />
                </div> */}
              </div>
            </div>

            {/* Step 3: Gender
            <div className="form-step mt-0">
              <div className="form-grid">
                <div className="form-group">
                  <label>
                    <Clock size={14} />
                    النوع *
                  </label>
                  <select
                    name="gender"
                    value={formData.gender}
                    onChange={handelGender}
                    required
                  >
                    <option value="">اختري</option>
                    {timeSlots.map((slot) => (
                      <option key={slot} value={slot}>{slot}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div> */}

            <motion.button
              type="submit"
              className="btn-submit"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              disabled={!formData.notes || !formData.name || !formData.phone || !formData.gender}
            >
              تأكيد الحجز
              <ChevronLeft size={18} />
            </motion.button>
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default Booking;